import { useQuery } from '@tanstack/react-query';

import VendorsService from '~/services/VendorsService';

import { VendorPeriodSummary } from '~/types/services/vendor';

export type VendorSummaryType = 'all' | 'lpc';

// Period shape (YYYY-MM vs YYYY-Qn) is the only cache discriminator we need — BE
// infers granularity from it, so we don't include granularity in the key.
export const vendorSummaryQueryKeys = {
  all: ['vendor-summary'] as const,
  detail: (vendorId: string, period: string, type: VendorSummaryType) =>
    [...vendorSummaryQueryKeys.all, vendorId, period, type] as const,
};

type Params = {
  vendorId: string | null;
  period: string;
  type?: VendorSummaryType;
  enabled?: boolean;
};

export function useGetVendorSummary({ vendorId, period, type = 'all', enabled = true }: Params) {
  return useQuery({
    queryKey: vendorSummaryQueryKeys.detail(vendorId ?? '', period, type),
    queryFn: async ({ signal }): Promise<VendorPeriodSummary> => {
      if (!vendorId) throw new Error('vendorId is required');
      const response = await VendorsService.getVendorSummary(vendorId, { period, type }, { signal });
      return response.data as VendorPeriodSummary;
    },
    enabled: enabled && !!vendorId && !!period,
    staleTime: 5 * 60 * 1000,
  });
}
